module.exports = __webpack_public_path__ + "img/letter_of_wishes.f17914f4.svg";